import React, { Component } from "react";
import PropTypes from "prop-types";
import { service, actions } from "./data";
import { injectIntl, intlShape } from "@ai360/core/intl";
import { withCrud, withMasked } from "~/hocs";
import { DataTable } from "~/core";
import { FormattingHelpers } from "@ai360/core";
import { memoizeFormattedRecords } from "~/admin/utils";
import { messages } from "../../i18n-messages";

export class ProductLog_ extends Component {
    static propTypes = {
        records: PropTypes.array,
        intl: intlShape.isRequired,
    };
    getFormattedRecords = memoizeFormattedRecords(FormattingHelpers.formatLogDetailText);
    render() {
        return (
            <DataTable
                service={service}
                isCheckbox={false}
                showFilterInput={false}
                messages={messages}
                {...this.props}
                records={this.getFormattedRecords((this.props as any).records)}
            />
        );
    }
}
export const ProductLog = injectIntl(withMasked(withCrud(ProductLog_, service, actions)));
